// EspaceProSectionsNav — DÉSACTIVÉ - Remplacé par menu hamburger
// L'utilisateur a demandé de supprimer cette barre horizontale
// et d'utiliser uniquement le menu hamburger en haut à droite

import { useLocation } from 'react-router-dom';

export default function EspaceProSectionsNav() {
  // DÉSACTIVÉ - On utilise uniquement le menu hamburger maintenant
  return null;
}

// Spacer également désactivé
export function EspaceProSectionsNavSpacer() {
  return null;
}
